module.exports = __webpack_public_path__ + "img/booth1_home.9c5977b0.jpg";